import type { PromotePageMainData } from '../../types';

export function getComboBanditExpAmountChoices({
	revenueBanditsPsfComboButtonAmounts,
	amountChoices,
	psfStaticAmount,
}: {
	revenueBanditsPsfComboButtonAmounts: PromotePageMainData['revenueBanditsPsfComboButtonAmounts'];
	amountChoices: readonly number[];
	psfStaticAmount: number;
}): number[] {
	if (!revenueBanditsPsfComboButtonAmounts) {
		return [psfStaticAmount, ...amountChoices.slice(1)];
	}

	// pick a random set of button amounts
	const randomIndex = Math.floor(Math.random() * revenueBanditsPsfComboButtonAmounts.length);
	const buttonAmounts = revenueBanditsPsfComboButtonAmounts[randomIndex].amounts;
	return [psfStaticAmount, ...buttonAmounts];
}
